(function () {
  'use strict';

  const DISCOUNT_TIERS = [
    { items: 2, pct: 10, label: '-10% EXTRA OFF' },
    { items: 3, pct: 15, label: '-15% EXTRA OFF' },
    { items: 4, pct: 20, label: '-20% EXTRA OFF' },
    { items: 5, pct: 25, label: '-25% EXTRA OFF' }
  ];

  const SELECTORS = {
    drawer: '[data-cart-drawer]',
    closeBtns: '[data-cart-close]',
    body: '[data-cart-body]',
    items: '[data-cart-items]',
    empty: '[data-cart-empty]',
    count: '[data-cart-count]',
    total: '[data-cart-total]',
    progressFill: '[data-progress-fill]',
    progressText: '[data-progress-text]',
    progressSteps: '[data-cart-progress] .mb-cart__step',
    discountRow: '[data-discount-row]',
    discountPct: '[data-discount-pct]',
    discountAmount: '[data-discount-amount]',
    itemBadge: '[data-item-discount-badge]',
    itemBadgePct: '[data-item-discount-pct]',
    upsellTrack: '[data-upsell-track]',
    upsellPrev: '[data-upsell-prev]',
    upsellNext: '[data-upsell-next]',
    upsellForms: '[data-upsell-form]'
  };

  const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }

  /* ---------- PRODUCT CACHE for compare_at_price ---------- */
  const productCache = {};
  function getProductData(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function toCents(val) {
    if (val == null) return null;
    if (typeof val === 'number') return val;
    if (typeof val === 'string') {
      const n = parseFloat(val);
      if (isNaN(n)) return null;
      return val.indexOf('.') >= 0 ? Math.round(n * 100) : n;
    }
    return null;
  }

  function enrichCartItems(cart) {
    if (!cart.items || cart.items.length === 0) return Promise.resolve(cart);
    const handles = Array.from(new Set(cart.items.map(function (i) { return i.handle; })));
    return Promise.all(handles.map(getProductData)).then(function () {
      cart.items.forEach(function (item) {
        if (item.compare_at_price && item.compare_at_price > 0) return;
        const product = productCache[item.handle];
        if (!product || !product.variants) return;
        const variant = product.variants.find(function (v) { return v.id === item.variant_id; });
        if (variant && variant.compare_at_price) {
          const cap = toCents(variant.compare_at_price);
          if (cap && cap > 0) item.compare_at_price = cap;
        }
      });
      return cart;
    });
  }

  function currentTier(itemCount) {
    let active = null;
    for (let i = 0; i < DISCOUNT_TIERS.length; i++) {
      if (itemCount >= DISCOUNT_TIERS[i].items) active = DISCOUNT_TIERS[i];
      else break;
    }
    return active;
  }

  function nextTier(itemCount) {
    for (let i = 0; i < DISCOUNT_TIERS.length; i++) {
      if (itemCount < DISCOUNT_TIERS[i].items) return DISCOUNT_TIERS[i];
    }
    return null;
  }

  const drawer = $(SELECTORS.drawer);
  if (!drawer) return;

  let lastFocusedTrigger = null;

  function open(trigger) {
    lastFocusedTrigger = trigger || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mb-cart-open');
    Array.from(document.body.children).forEach(function (el) {
      if (el !== drawer && !el.contains(drawer)) {
        el.setAttribute('data-mb-prev-inert', el.hasAttribute('inert') ? '1' : '0');
        el.setAttribute('inert', '');
      }
    });
    const focusable = drawer.querySelector('button, a, input, select');
    if (focusable) focusable.focus();
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mb-cart-open');
    Array.from(document.body.children).forEach(function (el) {
      if (el.getAttribute('data-mb-prev-inert') === '0') el.removeAttribute('inert');
      el.removeAttribute('data-mb-prev-inert');
    });
    if (lastFocusedTrigger && typeof lastFocusedTrigger.focus === 'function') {
      lastFocusedTrigger.focus();
    }
    lastFocusedTrigger = null;
  }

  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const focusables = drawer.querySelectorAll('button:not([disabled]), a, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
  drawer.addEventListener('click', function (e) {
    if (e.target.closest(SELECTORS.closeBtns)) {
      e.preventDefault(); close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest(
      'a[href="/cart"], a[href$="/cart"], .js-drawer-open-cart, [data-cart-open], [data-drawer-open="cart"]'
    );
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open(trigger);
    }
  }, true);

  function buildItemHTML(item) {
    var qty = item.quantity || 1;
    var finalUnit = Number(item.final_price) || 0;
    var compareUnit = Number(item.compare_at_price) || 0;
    var finalLine = (typeof item.final_line_price === 'number' && item.final_line_price > 0) ? item.final_line_price : finalUnit * qty;
    var compareLine = compareUnit * qty;
    var hasSale = compareLine > 0 && compareLine > finalLine;
    var savings = hasSale ? compareLine - finalLine : 0;

    let optionsHTML = '';
    if (item.options_with_values && item.options_with_values.length) {
      const realOpts = item.options_with_values.filter(function (o) {
        return !(o.name === 'Title' && o.value === 'Default Title');
      });
      if (realOpts.length) {
        optionsHTML = '<p class="mb-cart-item__options">' +
          realOpts.map(function (o) {
            return '<span class="mb-cart-item__option"><strong>' + escapeHTML(o.name) + ':</strong> ' + escapeHTML(o.value) + '</span>';
          }).join(', ') +
        '</p>';
      }
    }

    let imgSrc = '';
    if (item.image) {
      try {
        const u = new URL(item.image, window.location.origin);
        u.searchParams.set('width', '200');
        imgSrc = u.toString();
      } catch (err) {
        imgSrc = item.image;
      }
    }

    return ''
      + '<li class="mb-cart-item" data-cart-item data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">'
      +   '<a href="' + item.url + '" class="mb-cart-item__image-wrap" tabindex="-1">'
      +     (imgSrc ? '<img class="mb-cart-item__image" src="' + imgSrc + '" alt="' + escapeHTML(item.product_title) + '" width="100" height="120" loading="lazy">' : '')
      +   '</a>'
      +   '<div class="mb-cart-item__body">'
      +     '<div class="mb-cart-item__top">'
      +       '<a href="' + item.url + '" class="mb-cart-item__title">' + escapeHTML(item.product_title) + '</a>'
      +       '<button type="button" class="mb-cart-item__remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove">'
      +         '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 6h18 M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2 M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>'
      +       '</button>'
      +     '</div>'
      +     optionsHTML
      +     '<div class="mb-cart-item__price-row">'
      +       (hasSale ? '<span class="mb-cart-item__price-old">' + formatMoney(compareLine) + '</span>' : '')
      +       '<span class="mb-cart-item__price">' + formatMoney(finalLine) + '</span>'
      +       (hasSale ? '<span class="mb-cart-item__savings">(Save ' + formatMoney(savings) + ')</span>' : '')
      +     '</div>'
      +     '<div class="mb-cart-item__bottom">'
      +       '<div class="mb-cart-item__qty">'
      +         '<button type="button" class="mb-cart-item__qty-btn" data-qty-decrease data-key="' + item.key + '" aria-label="Decrease">-</button>'
      +         '<input class="mb-cart-item__qty-input" type="text" inputmode="numeric" pattern="[0-9]*" value="' + item.quantity + '" data-qty-input data-key="' + item.key + '" aria-label="Quantity">'
      +         '<button type="button" class="mb-cart-item__qty-btn" data-qty-increase data-key="' + item.key + '" aria-label="Increase">+</button>'
      +       '</div>'
      +       '<span class="mb-cart-item__discount-badge" data-item-discount-badge hidden>'
      +         '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.4" fill="currentColor"/></svg>'
      +         '<span data-item-discount-pct>-10% EXTRA OFF</span>'
      +       '</span>'
      +     '</div>'
      +   '</div>'
      + '</li>';
  }

  function escapeHTML(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function updateFromCart(cart) {
    $$(SELECTORS.count).forEach(function (el) { el.textContent = cart.item_count; });
    const tier = currentTier(cart.item_count);
    const discountAmount = tier ? Math.round(cart.items_subtotal_price * (tier.pct / 100)) : 0;
    const finalTotal = cart.items_subtotal_price - discountAmount;
    $$(SELECTORS.total).forEach(function (el) { el.textContent = formatMoney(finalTotal); });

    const itemsList = $(SELECTORS.items);
    const emptyEl = $(SELECTORS.empty);
    const upsellEl = $('[data-cart-upsell]');
    const progressEl = $('[data-cart-progress]');
    if (itemsList) {
      if (cart.item_count === 0) {
        itemsList.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (upsellEl) upsellEl.hidden = true;
        if (progressEl) progressEl.hidden = true;
      } else {
        if (emptyEl) emptyEl.hidden = true;
        if (upsellEl) upsellEl.hidden = false;
        if (progressEl) progressEl.hidden = false;
        itemsList.innerHTML = cart.items.map(buildItemHTML).join('');
      }
    }

    updateProgress(cart.item_count);

    const dRow = $(SELECTORS.discountRow);
    const dPct = $(SELECTORS.discountPct);
    const dAmt = $(SELECTORS.discountAmount);
    if (tier) {
      if (dRow) dRow.hidden = false;
      if (dPct) dPct.textContent = tier.label;
      if (dAmt) dAmt.textContent = '- ' + formatMoney(discountAmount);
    } else if (dRow) {
      dRow.hidden = true;
    }

    $$('[data-item-discount-badge]').forEach(function (b) {
      const pctEl = b.querySelector('[data-item-discount-pct]');
      if (tier) {
        if (pctEl) pctEl.textContent = tier.label;
        b.hidden = false;
      } else {
        b.hidden = true;
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function updateProgress(itemCount) {
    const text = $(SELECTORS.progressText);
    const fill = $(SELECTORS.progressFill);
    const steps = $$(SELECTORS.progressSteps);

    const next = nextTier(itemCount);
    if (text) {
      if (next) {
        const remaining = next.items - itemCount;
        text.textContent = 'Add ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' to save an extra ' + next.pct + '%!';
      } else {
        text.textContent = 'You unlocked the maximum discount!';
      }
    }

    const totalSteps = steps.length;
    let reachedIdx = -1;
    steps.forEach(function (step, i) {
      const threshold = parseInt(step.getAttribute('data-threshold'), 10);
      if (itemCount >= threshold) {
        step.classList.add('is-active');
        reachedIdx = i;
      } else {
        step.classList.remove('is-active');
      }
    });

    if (fill) {
      let pct = 0;
      if (reachedIdx >= 0) {
        pct = ((reachedIdx + 0.5) / totalSteps) * 100;
      }
      fill.style.width = pct + '%';
    }
  }

  function refreshCart() {
    return fetchJSON('/cart.js').then(enrichCartItems).then(updateFromCart);
  }

  function changeQty(key, qty) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(enrichCartItems).then(updateFromCart).catch(function (err) {
      console.error('changeQty error', err);
      return refreshCart();
    });
  }

  const qtyTimers = {};
  function debouncedQty(key, qty) {
    if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      changeQty(key, qty);
    }, 220);
  }

  function addToCart(formData) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(formData)
    }).then(function () { return refreshCart(); });
  }

  drawer.addEventListener('click', function (e) {
    const dec = e.target.closest('[data-qty-decrease]');
    const inc = e.target.closest('[data-qty-increase]');
    const rem = e.target.closest('[data-cart-remove]');
    const upAdd = e.target.closest('[data-upsell-add]');
    const upPrev = e.target.closest(SELECTORS.upsellPrev);
    const upNext = e.target.closest(SELECTORS.upsellNext);

    if (dec) {
      const key = dec.getAttribute('data-key');
      const input = drawer.querySelector('[data-qty-input][data-key="' + key + '"]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 0;
      const next = Math.max(0, current - 1);
      input.value = next;
      debouncedQty(key, next);
      return;
    }
    if (inc) {
      const key = inc.getAttribute('data-key');
      const input = drawer.querySelector('[data-qty-input][data-key="' + key + '"]');
      if (!input) return;
      const next = (parseInt(input.value, 10) || 0) + 1;
      input.value = next;
      debouncedQty(key, next);
      return;
    }
    if (rem) {
      const key = rem.getAttribute('data-key');
      changeQty(key, 0);
      return;
    }
    if (upAdd) {
      e.preventDefault();
      const form = upAdd.closest('[data-upsell-form]');
      const variant = form.querySelector('[data-upsell-variant]');
      if (!variant) return;
      upAdd.disabled = true; upAdd.textContent = '...';
      addToCart({ id: parseInt(variant.value, 10), quantity: 1 })
        .then(function () { upAdd.disabled = false; upAdd.textContent = 'Add'; })
        .catch(function () { upAdd.disabled = false; upAdd.textContent = 'Add'; });
      return;
    }
    if (upPrev || upNext) {
      const track = $(SELECTORS.upsellTrack);
      if (track) {
        const delta = upPrev ? -track.clientWidth : track.clientWidth;
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }
  });

  drawer.addEventListener('change', function (e) {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const key = input.getAttribute('data-key');
    let qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeQty(key, qty);
  });

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.closest(SELECTORS.drawer)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const submitBtn = form.querySelector('[type="submit"]');
    const originalBtnText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) { submitBtn.disabled = true; }

    const fd = new FormData(form);
    const obj = {};
    fd.forEach(function (v, k) { obj[k] = v; });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(obj)
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    })
    .then(function () {
      return refreshCart().then(function () { open(submitBtn); });
    })
    .catch(function (err) {
      console.error('Add to cart error', err);
      if (err && err.description) alert(err.description);
    })
    .finally(function () {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalBtnText; }
    });
  }, true);

  let didInit = false;
  function init() {
    if (didInit) return;
    didInit = true;
    refreshCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();